module.exports = __webpack_public_path__ + "static/img/ticket_item_bg_type1.1aac3291.png";